import { useStorageService } from '~/composables/services/useStorageService';
import { useMarketingService } from '~/composables/services/useMarketingService';
import { useAuthStore } from '~/stores/auth.store';
import { useSiteStore } from '~/stores/site.store';
import { useAddMarketingSession } from '~/composables/useAddMarketingSession';
import { globalKeys } from 'assets/data/global-keys';

export default defineNuxtPlugin({
  name: 'marketing-optin',
  enforce: 'post',
  parallel: true,
  dependsOn: ['init-client'],
  hooks: {
    async 'app:mounted'() {
      const runtimeConfig = useRuntimeConfig();

      const { $enabled } = useNuxtApp();

      const { localeKey } = useLocaleUtils();
      const auth = useAuthStore();
      const site = useSiteStore();
      const route = useRoute();
      const { query } = route;

      const $storageService = useStorageService();
      const $marketingService = useMarketingService();

      if (site.isWebview) return;

      const requestInfo = await $marketingService.fetchDeviceInfo();

      if (auth.loggedIn && !!query?.optin) {
        if (!!query?.optin) {
          await $marketingService
            .setMarketingOptIn({
              vendorAccountID: $storageService.getCookie({
                key: globalKeys.authKeys.userId,
              }),
              optinName: String(query?.optin),
              source: String(query?.source),
              countryCode: site.getRegionCode,
            })
            .then((d) => {
              if (typeof d === 'boolean' && d) {
                site.toggleSiteNotice({
                  heading: localeKey('marketing-opt-in-heading'),
                  content: {
                    data: localeKey('marketing-opt-in-message'),
                  },
                  severity: 'success',
                  enabled: true,
                  timeout: 5000,
                });
              }
            });
        }
      } else if (!auth.loggedIn && !!query?.optin) {
        $storageService.setLocalStorage({
          key: globalKeys.marketingKeys.optinSession,
          data: JSON.stringify({
            optin: query.optin,
            source: query.source,
          }),
        });

        watch(
          () => auth.loggedIn,
          async (value) => {
            if (value) {
              const optin: Record<string, string> =
                $storageService.getLocalStorage({
                  key: globalKeys.marketingKeys.optinSession,
                });
              await $marketingService
                .setMarketingOptIn({
                  vendorAccountID: $storageService.getCookie({
                    key: globalKeys.authKeys.userId,
                  }),
                  optinName: String(optin?.optin),
                  source: String(optin?.source),
                  countryCode: site.getRegionCode,
                })
                .then((d) => {
                  if (typeof d === 'boolean' && d) {
                    site.toggleSiteNotice({
                      heading: localeKey('marketing-opt-in-heading'),
                      content: {
                        data: localeKey('marketing-opt-in-message'),
                      },
                      severity: 'success',
                      enabled: true,
                      timeout: 5000,
                    });
                    $storageService.removeLocalStorage({
                      key: globalKeys.marketingKeys.optinSession,
                    });
                  }
                });
            }
          },
        );
      }

      //Create marketing session if none exists

      watchEffect(async () => {
        if (auth.isLoggedIn) await useAddMarketingSession();
      });

      // lexis nexis threat metrix
      window.ProfileInit = (hash: string, s: string = '100') => {
        if (!!window?.thkdlhgd)
          window.thkdlhgd.prgssdw(
            document.location.hostname.replace(
              /^(www|uat|qa|dev|sandbox)/,
              'info',
            ),
            'b5upb58k',
            hash,
            s,
          );
      };

      const { onLoaded } = useScript(
        {
          src: runtimeConfig.public.threadMetrixScript,
          tagPosition: 'head',
          async: 'true',
          defer: 'true',
          id: 'threat-metrix',
          crossorigin: false,
        },
        {
          bundle: true,
          trigger: computed(
            () =>
              !window?.thkdlhgd &&
              $enabled('website.threatmetrix') &&
              !!requestInfo.hash,
          ),
        },
      );

      onLoaded(() => {
        if (!!window?.ProfileInit) window?.ProfileInit(requestInfo.hash);
      });
    },
  },
});
